import { AchievementName } from '@helios/achievement';
import classNames from 'classnames';
import { badgeSvgMap, svgStyleAdjustments } from './BadgeSvgs';

const mapAchievementNameToSvg = (achievementName: AchievementName, achieved: boolean) => {
  const badgeEntry = badgeSvgMap[achievementName];
  if (!badgeEntry) {
    return null;
  }
  return achieved ? badgeEntry.achieved : badgeEntry.unachieved;
};

interface BadgeIconProps {
  achievementName: AchievementName;
  achieved?: boolean;
  className?: string;
}

export const BadgeIcon: React.FC<BadgeIconProps> = ({ achievementName, achieved, className }) => {
  const SvgIcon = mapAchievementNameToSvg(achievementName, achieved ?? false);
  if (!SvgIcon) {
    return null;
  }

  const svgClass = classNames(
    'overflow-visible pointer-events-none',
    achieved && svgStyleAdjustments[achievementName],
  );

  const containerClass = classNames('relative overflow-visible', className);

  return (
    <div className={containerClass}>
      <SvgIcon className={svgClass} />
    </div>
  );
};
